import { memo } from "react";
import Box from "@mui/material/Box";
import { when } from "util/support";
import Tabs from "ui/atoms/Tabs";
import {
    PaymentMethodDetailTab,
    usePaymentMethodContext
} from "../PaymentMethodProvider";
import BasicInfo from "./BasicInfo";
import SpecInParams from "./SpecInParams";
import MerchantsEnable from "./MerchantsEnable";

const PaymentMethodDetail = () => {
    const { onChange, selectBasicInfo, getPaymentMethod } = usePaymentMethodContext();

    return (
        <Box>
            <Tabs
                model={[
                    {
                        key: PaymentMethodDetailTab.BasicInfo,
                        label: 'Basic Info',
                        component: (
                            <BasicInfo />
                        ),
                        sxProps: {
                            py: 2
                        }
                    },
                    {
                        key: PaymentMethodDetailTab.MerchantsEnable,
                        label: 'Merchants enabled',
                        component: (
                            <MerchantsEnable
                                {...getPaymentMethod()}
                            />
                        ),
                        sxProps: {
                            py: 2
                        }
                    },
                    {
                        key: PaymentMethodDetailTab.SpecificInputParameters,
                        label: 'Specific Input Parameters',
                        component: (
                            <SpecInParams />
                        )
                    }
                ]
                    .filter(({ key }) => when(
                        !selectBasicInfo().values.requireSpecIn,
                        () => !Object.is(key, PaymentMethodDetailTab.SpecificInputParameters),
                        () => true
                    ))}
                TabListContainerProps={{
                    borderBottom: 1,
                    borderColor: 'divider'
                }}
                TabListProps={{
                    'aria-label': 'payment method setups',
                    variant: 'scrollable',
                    scrollButtons: 'auto'
                }}
                onChange={onChange}
            />
        </Box>
    );
};

export default memo(PaymentMethodDetail);
